import script from "./ABSVehicleTrafficFines.vue?vue&type=script&setup=true&lang=js"
export * from "./ABSVehicleTrafficFines.vue?vue&type=script&setup=true&lang=js"

import "./ABSVehicleTrafficFines.vue?vue&type=style&index=0&id=86810c5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86810c5e"]])

export default __exports__